module.exports = __webpack_public_path__ + "img/credit-card-header.cc2755db.svg";